import {Component, DestroyRef, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {CurrentCrudSelectBehaviorServiceAsString, SnackBarService} from '../objectPassingService';
import {Router} from '@angular/router';
import {AdgroupService} from '../adgroups/adgroups_service';
import {CreateAdgroupInitPayload} from '../adgroups/adgroups.component';
import {GetAllAdgroupPayloadModel} from '../adgroups/adgroup_interfaces';
import {environment} from '../../environments/environment';
import {MatButton} from '@angular/material/button';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatProgressBar} from '@angular/material/progress-bar';

import {MatOption, MatSelect, MatSelectModule} from '@angular/material/select';

import { AdGroupType } from '../adgroups/adgroup_interfaces';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {classNames} from '@angular/cdk/schematics';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader} from '@angular/material/card';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


function isCreateAdgroupInitPayload(obj: any): obj is CreateAdgroupInitPayload {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.is_edit === false &&
    Object.keys(obj).length === 1
  );
}

function isGetAllAdgroupPayloadModel(obj: any): obj is GetAllAdgroupPayloadModel {
  /*
  The reason we kept both isCreateAdInitPayload() and isGetAllAdPayloadModel() was:
	•	To future-proof (in case is_edit accidentally shows up in GetAllAdPayloadModel)
	•	To keep the checks isolated and testable
	•	To avoid assumptions in the “else” branch
   */
  return obj && typeof obj === 'object' && typeof obj.name === 'string';
}

@Component({
  selector: 'app-adgroups-meta',
  imports: [
    FormsModule,
    MatSelectModule,
    MatButton,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatProgressBar,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    MatSlideToggle,
    MatCard,
    MatCardActions,
    MatCardHeader,
    MatCardContent
],
  templateUrl: './adgroups-meta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './adgroups-meta.component.css'
})
export class AdgroupsMetaComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  adTag!: SafeHtml;


  is_edit = false;
  is_form_error: boolean = false;
  form_error_message: string = "";
  myForm!: FormGroup;
  title_text = "Create Adgroup";
  submit_text = "Create"


  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  campaign_group_id: string = '';
  campaign_id: string = '';
  adgroup_id: string = '';
  ad_id: string = '';
  is_loading = true;

  constructor(
    private fb: FormBuilder,
    private snackBarService: SnackBarService,
    public router: Router, //all components need this
    private currentCrudSelectBehaviorService: CurrentCrudSelectBehaviorServiceAsString,
    private adgroupService: AdgroupService,
    private sanitizer: DomSanitizer
  ) {} // end constructor

  ngOnInit(): void {


    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_sequence_id = localStorage.getItem('campaign_group_sequence_id') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    this.campaign_id = localStorage.getItem('campaign_id') || '';
    this.adgroup_id = localStorage.getItem('adgroup_id') || '';
    console.log('adgroup_id!!!!!!!!!!!!!!!!!',this.adgroup_id)

    const tag = `
&lt;script&gt;
  var cb = Date.now();
  document.write('&lt;img src="https://test.com/serve?campaign_group_sequence_id=12345&amp;cb=' + cb + '" alt="Adgroup Type Image" width="300" height="250" style="border:0;display:block;"&gt;');
&lt;/script&gt;
&lt;noscript&gt;
  &lt;img src="https://test.com/serve?campaign_group_sequence_id=12345&amp;cb=1" alt="Adgroup Type Image" width="300" height="250" style="border:0;display:block;"&gt;
&lt;/noscript&gt;
    `;
    this.adTag = this.sanitizer.bypassSecurityTrustHtml(tag);


    // Use localStorage data on reload
    const savedAdgroupMeta = localStorage.getItem('adgroupsaved');

    if (savedAdgroupMeta) {
      // now if I want I can ... if exists go back to ads rather than having
      // to deal with updating saved storage e.g. on input update saved storage
      // will keep on for development for now
      //this.backToAds()

      if (environment.environment == 'production') {
        this.backToAdgroups()
      }

      try {
        const parsed = JSON.parse(savedAdgroupMeta);
        if (isCreateAdgroupInitPayload(parsed)) {
          const obj: CreateAdgroupInitPayload = parsed;
          console.log('[Reload] Editing state:', obj);
          this.setForm(); // Or pass in data if needed
          this.is_edit = obj.is_edit;
        } else if (isGetAllAdgroupPayloadModel(parsed)) {
          const obj: GetAllAdgroupPayloadModel = parsed;
          console.log('[Reload] Ad Data:', obj);
          this.setForm(obj);
          this.is_edit = true;
          this.adgroup_id = obj.adgroup_id;
          console.log('[Reload] Adgroup ID:', this.adgroup_id);
        }
      } catch (e) {
        console.error('Error parsing localStorage adsaved:', e);
      }
    } // end if savedAdMeta

    // Subscriptions from services (live interaction)
    this.currentCrudSelectBehaviorService.current$.pipe(takeUntil(this.destroyed)).subscribe(x => {
      if (!x) return;

      try {
        const parsed = JSON.parse(x);

        if (isCreateAdgroupInitPayload(parsed)) {
          console.log('[Stream] Create Payload:', parsed);
          this.setForm();
          this.is_edit = parsed.is_edit;
        } else if (isGetAllAdgroupPayloadModel(parsed)) {
          console.log('[Stream] Edit Payload:', parsed);
          this.adgroup_id = parsed.adgroup_id;
          console.log('[Stream] Adgroup ID:', this.adgroup_id);
          this.setForm(parsed);
          this.is_edit = true;
        } else {
          throw new Error('Unknown payload structure');
        }

        localStorage.setItem('adgroupsaved', JSON.stringify(parsed));
      } catch (e) {
        console.error('Error parsing stream payload:', e);
      }
    }); // end subscription

  } // end ngOnInit

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } // end ngOnDestroy

  setForm(data?: GetAllAdgroupPayloadModel) {

    if (!data) {

      this.myForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        status: new FormControl(false),
        type: new FormControl('sms'),

      });

    } else {
      this.submit_text = "Edit"

      let is_status =false;
      if (data.status == "active") {
        is_status = true;
      } else {
        is_status = false;
      }

      this.myForm = this.fb.group({
        name: [data.name],
        status: new FormControl(is_status),
        type: new FormControl(data.type),

      });
    }

    this.is_loading = false
  } // setForm

  backToAdgroups() {
    localStorage.removeItem('adgroupsaved')
    //this.router.navigate(['/nav-campaigns', {outlets: {admeta: ['ads']}}]);
    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['adgroups'] } }]).then(r => console.log('redirect to adgroups'));
  } // end backToAds

  onFocus(){
    console.log('onFocus')
    this.is_form_error = false;
    this.form_error_message = "";

    console.log(this.myForm.value );
  }

  onSubmit(){

    this.is_loading = true;
    let form_data = this.myForm.value;
    form_data['client_id'] =  this.client_id  //Math.floor(parseInt(form_data['client_id'], 10));
    console.log(form_data)

    let status = 'paused';
    if (form_data['status'] == true) {
      status = 'active';
    } else {
      status = 'paused';
    }
    form_data['status'] = status;

    if (!this.is_edit) {

      this.adgroupService.post(`adserver/adgroup/create/${this.client_id}/${this.campaign_group_sequence_id}/${this.campaign_group_id}/${this.campaign_id}`, form_data).pipe(takeUntil(this.destroyed)).subscribe(x => {
        this.snackBarService.announceSackBar('AdGroup Created');
        this.is_loading = false;
        this.backToAdgroups();
      }, error => {
        console.log('error',error)

      });

    } else {

      console.log('we are editing',this.adgroup_id)
      let endpoint = `adserver/adgroup/${this.adgroup_id}`;

      console.log('endpointsfgsdfgsdfgsdfgsfdggf!!!!!',endpoint)
      this.adgroupService.put(endpoint, form_data).subscribe(x => {
        this.snackBarService.announceSackBar('AdGroup Updated');
        this.is_loading = false;
      }, error => {
        this.is_loading = false;
        this.snackBarService.announceSackBar('AdGroup Update Error');
        console.log('error',error)
      });


    } //end if

  } // end OnSubmit

  protected readonly Date = Date;
} // end AdgroupsMetaComponent
